import React from 'react';
import {Helmet} from 'react-helmet';

const PreloadHelmetLinks = ({images}) => {
  const hasWebpImages = images?.every(image => image?.webp);
  const hasPngImages = images?.every(image => image?.png);

  if (hasWebpImages) {
    return (
      <Helmet>
        {
          images?.map(image => (
            <link rel='preload' fetchpriority='high' as='image' imageSrcSet={image?.webp} href={image?.png}/>
          ))
        }
      </Helmet>
    );
  }

  if (hasPngImages) {
    return (
      <Helmet>
        {
          images?.map(image => (
            <link rel='preload' fetchpriority='high' as='image' href={image?.png} />
          ))
        }
      </Helmet>
    );
  }

  return '';
}

export default PreloadHelmetLinks;
